/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OpenContractContainer_viewer$ref: FragmentReference;
export type OpenContractContainer_viewer = {|
  +id: string,
  +$refType: OpenContractContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "OpenContractContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '09bb913b0aaeb3d19d34c6d78b9ed62b';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Share/__generated__/OpenContractContainer_viewer.graphql.js